<template lang="pug">
  a-page-header
    a-row.row-bg(type="flex" justify="space-between")
      a-col(style="display:flex; justify-content: center;" :span="8")
        course-group-manager
      a-col(style="display:flex; justify-content: center;" :span="8")
        el-row(style="display:flex; justify-content: center;" type="flex" :gutter="8" justify="end")
          el-col
            course-select-system
          el-col
            message-room
          el-col
            user-login-drawer
</template>

<script>
import UserLoginDrawer from "@/components/Drawer/UserLoginDrawer";
import CourseGroupManager from "@/components/Drawer/CourseGroupManager";
import MessageRoom from "@/components/Drawer/MessageRoom";
import CourseSelectSystem from "@/components/Outline/CourseSelectSystem";
import LogoTitle from "@/components/Outline/LogoTitle";

export default {
  name: "TopNavBar",
  components: {LogoTitle, CourseSelectSystem, MessageRoom, CourseGroupManager, UserLoginDrawer},
  data() {
    return {
      showLoginDrawer: false,
    };
  },
  methods: {
    showLogin() {
      this.$store.state.user.loginInfo.showLoginDrawer = true
    }
  }
}
</script>

<style>
.nav-bar {
  spacing-left: 0px;
  padding-right: 0px;
}

</style>
